import { Component, Input } from '@angular/core';
import { OffersOfApplication } from '../../../../type/result_type';
import { ResultpageService } from '../../../../service/resultpage.service';
import { ResultpagesharedService } from '../../../../service/resultpageshared.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-offer-details',
  templateUrl: './mobile-offer-details.component.html',
  styleUrl: './mobile-offer-details.component.scss',
})
export class MobileOfferDetailsComponent {
  @Input() cardData!: OffersOfApplication;

  public interestExplanationHintText =
    'Der Zweidrittelzins dient der Vergleichbarkeit von Krediten mit bonitätsabhängiger Verzinsung. Die Bank gewährt mindestens zwei von drei angenommenen Kunden den Kredit zu diesem Zweidrittelzinssatz oder zu einem günstigeren Zinssatz.';

  public showMobInterestExplanation!: boolean;
  constructor(public sharedResultService: ResultpagesharedService) {}

  ngOnInit(): void {
    this.showMobInterestExplanation =
      this.sharedResultService.showMobInterestExplanation.find(
        (el) => el.id === this.cardData.id
      )?.showMobInterestExplanation;
  }

  get hasCustomerRatings(): boolean {
    const productId =
      this.cardData?.bankProduct?.product?.productDetails?.productId;
    return productId
      ? this.sharedResultService.hasCustomerRatings(productId)
      : false;
  }

  ngOnDestroy() {}
}
